import { SourcingAnalytics } from 'api-clients/monolith';

import { Skeleton } from '@/components/ui/skeleton';
import { Typography } from '@/components/ui/typography';

import { useMetricContent } from './use-metric-content';

interface MetricIndicatorProps {
  metricKey: keyof SourcingAnalytics;
  value: string | number | null;
}

export function MetricIndicator({ metricKey, value }: MetricIndicatorProps) {
  const { label, icon } = useMetricContent({ metricKey });

  return (
    <div className="flex flex-row items-center justify-center gap-4">
      <img src={icon} alt="Metric" className="h-6 w-6" />
      <div className="flex flex-col items-start py-2">
        <Typography variant="subtitle1">{label}</Typography>
        <Typography variant="large2">{value ?? '-'}</Typography>
      </div>
    </div>
  );
}

MetricIndicator.Skeleton = function MetricIndicatorSkeleton({
  metricKey,
}: {
  metricKey: keyof SourcingAnalytics;
}) {
  const { label, icon } = useMetricContent({ metricKey });

  return (
    <div className="flex flex-row items-center justify-center gap-4">
      <img src={icon} alt="Metric" className="h-6 w-6" />
      <div className="flex flex-col items-start py-2">
        <Typography variant="subtitle1">{label}</Typography>
        <Skeleton className="mt-1 h-5 w-8" />
      </div>
    </div>
  );
};
